
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ReportPurTaxGrid extends Serenity.EntityGrid<ReportPurTaxRow, any> {
        protected getColumnsKey() { return ReportPurTaxColumns.columnsKey; }
        protected getDialogType() { return ReportPurTaxDialog; }
        protected getIdProperty() { return ReportPurTaxRow.idProperty; }
        protected getInsertPermission() { return ReportPurTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportPurTaxRow.localTextPrefix; }
        protected getService() { return ReportPurTaxService.baseUrl; }

        public mn: string;
        public year: string;
        public shop:string;

        constructor(container: JQuery) {
            super(container);
            let qryrow = Q.tryFirst(QRreport.QRywcSpecRow.getLookup().items,x => x.Id == 117)

           
            this.mn = qryrow.DocMonth ?? "";
            this.year = qryrow.DocYear ?? "";
            this.shop = qryrow.ShopId ?? "";
            //console.log(qryrow.DocMonth ?? "")
        }

        

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportPurTaxService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
        
            buttons.push(
                {
                    title: Q.text("PDf"), // *** Get button text from translation
                    cssClass: '.panel-pdf',
                    icon: 'fa fa-file-pdf-o text-red',
                    onClick: () => {
                        //var row = this.view.getRows();                        
                    const request = this.getView().params as ReportPurTaxData
                    if (!Q.isEmptyOrNull(this.mn)) {
                        request.Monthh = Q.tryFirst(QRreport.QMonthRow.getLookup().items, x => x.Months == this.mn).MonthName
                    }
                    request.Year = (Number(this.year)+543).toString();

                    let Para = Q.tryFirst(Administration.CsParaRow.getLookup().items, x => x.Id == 1)
                    request.BizName = Para.TaxInvName;
                    
                    if (!Q.isEmptyOrNull(this.shop)) {
                        let Shop = Q.tryFirst(InitialData.PsShopRow.getLookup().items, x => x.ShopId == this.shop)
                        request.ShopName = Shop.ShopRegName;
                        request.ShopTaxId = Shop.ShopTaxId;
                        request.ShopAddress = Shop.ShopRegAddressLine1 + " " + Shop.ShopRegAddressLine2 + " " + Shop.ShopRegAddressLine3;
                        request.BranchName = Shop.BranchName;

                    }else{
                        request.ShopName = Para.TaxInvName;
                        request.ShopTaxId = Para.TaxId;
                        request.ShopAddress = Para.TaxInvAddrLine1 + " " + Para.TaxInvAddrLine2 + " " + Para.TaxInvAddrLine3;
                        request.BranchName = "ทุกสาขา";
                      
                    }

                    
                    request.Details = this.view.getRows();
                    console.log(request.Details)
                    console.log(request)

                    Q.postToService({ service: this.getService() + '/ExportPdf', request: request, target: '_blank' })
                        // GeniuzPOS.Purchase.PoCNRTVService.GetNextNumber
                        
                    },
               
                }
            ); 
           
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpecPurTax/edit/117';
                        return false;
                    },
                }
            );       


            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();          

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
            
            this.view.setSummaryOptions({
                aggregators: [
                    
                    
                    new Slick.Aggregators.Sum('NetAmt'),
                    new Slick.Aggregators.Sum('VatAmt'),
                    new Slick.Aggregators.Sum('TotalAmt')
                   
                ]

                

            });     
            return grid;
        }

        protected createQuickSearchInput() {
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }
    }
}